import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateControlProgramRightsForUserMutation } from "org/user/queries/useUpdateControlProgramRightsForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { ControlProgramRow } from "./useUserControlProgramListTable";

interface UseReplaceControlProgramUserUtilsProps {
    userId: number;
    selectedRows: Row<ControlProgramRow>[];
    deselectAll: () => void;
}

export function useReplaceControlProgramUserUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplaceControlProgramUserUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdateControlProgramRightsForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = async (userOrGroup: UserOrUserGroupOverview) => {
        const controlProgramIds = selectedRows.map((row) => row.original.id);
        const newUserId = userOrGroup.id;
        try {
            await mutateAsync({
                userId,
                data: { newUserId, controlProgramIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        openReplaceUserModal: () => setIsModalOpen(true),
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
